import type { AccountNames } from "@dealer-center/ddc-api-account-interface";
import { useQuery } from "@tanstack/react-query";
import ky from "ky";

const queryKeyBase = "ddc-api-account-names";

const url = `/landing/nxlambda/account/names?accounts=`;

const staleTime = 600000; // 10 mins
export function useGetAccountNames(accountNames?: readonly string[]) {
  // remove duplicates, empty strings and sort
  const accountNamesToUse = (accountNames || [])
    .filter((name, index, self) => name && self.indexOf(name) === index)
    .sort();
  return useQuery({
    queryKey: [queryKeyBase, { accountNames: accountNamesToUse }],
    enabled: !!accountNamesToUse.length,
    queryFn: () => fetchAccountGet(accountNamesToUse),
    staleTime
  });
}

const fetchAccountGet = (accountNames: string[]) => {
  return ky.get(`${url}${accountNames.join(",")}`).json<AccountNames[]>();
};
